export enum EtimSlides {
  Etim = 'etim',
  EtimAttributes = 'etimAttributes',
  EtimAttributesKeywords = 'etimAttributesKeywords',
}
